// The one body-read discipline for REST clients — the received/failed
// split. The READ is deliberately catch-less: a stream that dies after the
// status line (machine sleep mid-request, dropped connection) rejects as
// the network error it is — a swallowing catch here once laundered
// sleep-truncated poll bodies into "ok, empty" and resolved undefined into
// loaded UI state. Only the PARSE of fully received text tolerates
// failure: empty or non-JSON text resolves undefined, and the caller
// decides what a missing body means for its endpoint.
export async function readJsonBody(response: Response): Promise<unknown> {
  const text = await response.text();
  try {
    return JSON.parse(text);
  } catch {
    // Swallowed on purpose — the text is fully received here, so a parse
    // failure is "no JSON body", never a network error.
  }
  return undefined;
}
